import axios from '../axios';

export function getCinemaList(data) {
    const url = "/cinema/list";
    return axios.request({
        url,
        method: 'get',
        data
    })
}

export function getCinemaInfo(data) {
    const url = `/cinema${data ? `/${data}` : ''}`;
    return axios.request({
        url,
        method: 'get',
        data
    })
}


export function getCinemaDetail(data) {
    const url = `/cinema${data ? `/${data}` : ''}`;
    return axios.request({
        url,
    })
}

export function getCinemaMovieShow(data) {
    const url = `/cinema/show${data ? `/${data}` : ''}`;
    return axios.request({
        url,
        method: 'get'
    })
}

export function getCinemaSeat(data) {
    const url = `/show/seat`;
    return axios.request({
        url,
        method: 'get',
        data
    })
}

export function createOrder(data) {
    const url = `/movie/order/create`;
    return axios.request({
        url,
        data,
    })
}


export function validateSelectedSeatList(data) {
    const url = `/show/seat/validSeatPosition`;
    return axios.request({
        url,
        data,
        method: 'get'
    })
}


export function getCinemaFood(data) {
    const url = `/cinema/bmh/list`;
    return axios.request({
        url,
        data: {
            cinemaId: data
        },
        method: 'get'
    })
}
